import React, { useEffect, useState } from "react";
import Section from "../../components/Section";
import { pageTitle } from "../../helpers/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import toast from "react-hot-toast";
import SecondaryButton from "../../components/SecondaryButton";
import { signInWithEmailAndPassword } from "firebase/auth";
import PageHeader from "../../components/PageHeader";
import InputField from "../../components/InputField";
import { auth } from "../../config/firebaseConfig";
import { BsEye } from "react-icons/bs";
import PasswordInputField from "../../components/PasswordField";
import axiosInstance from "../../utils/axiosInstance";
import { addEditService, deleteService, fetchDoctorProfile, fetchDoctorServicesList, registerUser, updateUserDetais } from "../../constants/ApiConstants";
import { Link, redirect, useNavigate } from "react-router-dom";
import SelectField from "../../components/SelectField";
import SelectField2 from "../../components/SelectField2";
import { countries } from "../../utils/countries";
import MobileNumberWithCountryCode from "../../components/MobileNumberWithCountryCode";
import DatePicker from "react-datepicker";
import { getYYYYmmddFromDate, isDesktop } from "../../utils/utils";
import { updateUserData } from "../../store/appSlice";
import CommonMobileHeader from "../../components/Header/CommonMobileHeader";
import FullPageLoader from "../../components/FullPageLoader";
import ListEmptyText from "../../components/ListEmptyText";
import MyModal from "../../components/MyModal";
import Spinner from "../../components/Spinner";

export default function ManageServices() {
  pageTitle("Manage Services");

  const [loading, setLoading] = useState(false);
  const doctorId = useSelector((state) => state.appSlice.doctorData?.id);
  const [doctorDetail, setDoctorDetail] = useState(null);

  const [editServiceData, setEditServiceData] = useState();
  const [deleteServiceId, setDeleteServiceId] = useState("");
  const [editServiceModalOpen, setEditServiceModalOpen] = useState(false);
  const [deleteServiceModalOpen, setDeleteServiceModalOpen] = useState(false);
  const [addServiceModalOpen, setAddServiceModalOpen] = useState(false);
  const [addServiceData, setAddServiceData] = useState(null);

  const [submitting, setSubmitting] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    fetchDoctorDetail();
  }, []);

  const fetchDoctorDetail = () => {
    setLoading(true);
    axiosInstance
      .post(fetchDoctorProfile, {
        doctor_id: doctorId,
      })
      .then((res) => {
        setDoctorDetail(res.data.data);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleEditPress = (serviceData) => {
    setEditServiceData(serviceData);
    setEditServiceModalOpen(true);
  };

  const handleDeletePress = (serviceData) => {
    setDeleteServiceId(serviceData.id);
    setDeleteServiceModalOpen(true);
  };

  const handleOpenAddServiceModal = () => {
    setAddServiceModalOpen(true);
    setAddServiceData({ title: "" });
  };

  const closeAddModal = () => setAddServiceModalOpen(false);
  const closeEditModal = () => setEditServiceModalOpen(false);
  const closeDeleteModal = () => setDeleteServiceModalOpen(false);

  const onAddSubmit = () => {
    if (!editServiceData?.title === "") {
      toast.error("Please provide service title");
      return;
    }
    setSubmitting(true);
    axiosInstance
      .post(addEditService, {
        doctor_id: doctorId,
        title: addServiceData?.title,
        type: 1,
      })
      .then((res) => {
        if (res.data?.status) {
          toast.success("Service added successfully.");
          setAddServiceData("");
          setAddServiceModalOpen(false);
          fetchDoctorDetail();
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const onEditSubmit = () => {
    if (!editServiceData?.title === "") {
      toast.error("Please provide service title");
      return;
    }
    setSubmitting(true);
    axiosInstance
      .post(addEditService, {
        doctor_id: doctorId,
        title: editServiceData?.title,
        service_id: editServiceData?.id,
        type: 2,
      })
      .then((res) => {
        if (res.data?.status) {
          toast.success("Service updated successfully.");
          setEditServiceData("");
          setEditServiceModalOpen(false);
          fetchDoctorDetail();
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const onDeleteClick = () => {
    setSubmitting(true);
    axiosInstance
      .post(addEditService, {
        doctor_id: doctorId,
        service_id: deleteServiceId,
        type: 3,
      })
      .then((res) => {
        if (res.data?.status) {
          toast.success("Service deleted successfully.");
          setDeleteServiceId("");
          setDeleteServiceModalOpen(false);
          fetchDoctorDetail();
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <Wrapper>
      {loading ? (
        <FullPageLoader />
      ) : (
        <Section topMd={0} topLg={0} topXl={110} bottomMd={200} bottomLg={150} bottomXl={110}>
          <div className="content-wrapper d-flex flex-column px-3 gap-1 justify-content-center mx-auto">
            <CommonMobileHeader
              canBack
              title="Services"
              trailing={
                <button type="button" className="bg-success-surface px-3 rounded" onClick={handleOpenAddServiceModal}>
                  Add Service
                </button>
              }
            />
            <div className="row">
              <div className="col-md-6">
                <div className="py-3 bg-white">
                  <strong className="text-dark">MANAGE SERVICES</strong>
                  <p className="text-grey2 fs-normal">Example: Hypertension Treatment, Obesity Treatment</p>
                </div>
              </div>
              <div className="col-md-6">
                {!loading && doctorDetail && doctorDetail?.services.length === 0 && <ListEmptyText text={"No service added yet."} />}
                {!loading && doctorDetail && doctorDetail?.services.length > 0 && (
                  <div className="w-full">
                    {doctorDetail?.services.map((service) => (
                      <div key={service.id} className="d-flex justify-content-between bg-grey2 mb-2 rounded">
                        <strong className="fs-normal text-grey2 fw-normal px-3 py-2  ">{service.title}</strong>
                        <div className="d-flex gap-2">
                          <button type="button" className="bg-warning-surface px-3 rounded" onClick={() => handleEditPress(service)}>
                            Edit
                          </button>
                          <button type="button" className="bg-danger-surface px-3 rounded" onClick={() => handleDeletePress(service)}>
                            Delete
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </Section>
      )}
      {/* Edit Service Modal */}
      <MyModal isOpen={editServiceModalOpen} modalTitle={"Edit Service"} onClose={closeEditModal}>
        <div className="d-flex flex-column gap-2 mt-3">
          <InputField name={"serviceName"} value={editServiceData?.title} onChange={(e) => setEditServiceData({ ...editServiceData, title: e.target.value })} />
          <SecondaryButton title="Continue" onClick={onEditSubmit} loading={submitting} />
        </div>
      </MyModal>
      {/* Add Service Modal */}
      <MyModal isOpen={addServiceModalOpen} modalTitle={"Add Service"} onClose={closeAddModal}>
        <div className="d-flex flex-column gap-2 mt-3">
          <InputField name={"serviceName"} value={addServiceData?.title} onChange={(e) => setAddServiceData({ ...editServiceData, title: e.target.value })} />
          <SecondaryButton title="Continue" onClick={onAddSubmit} loading={submitting} />
        </div>
      </MyModal>
      {/* Delete Modal */}
      <MyModal isOpen={deleteServiceModalOpen} modalTitle={"Delete Service"} onClose={closeDeleteModal}>
        <div className="d-flex flex-column gap-2 mt-3">
          <SecondaryButton title="Delete" onClick={onDeleteClick} loading={submitting} />
        </div>
      </MyModal>
    </Wrapper>
  );
}
const Wrapper = styled.div``;
